/**
 * 选择区域
 */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import styles from './SetRate.module.scss';
import { Modal, message, Divider } from 'antd';
import { XInputNum } from '@/components/xqxc_ui';
import model from '@/reducers/operation/service/model';
import { regFenToYuan, regYuanToFen } from '@/util/money';

const SetRate = ({
    closeModal,
    data: { id = '' },
    getServiceInfo,
    serviceInfo
}) => {

    const [loading, setLoading] = useState(false);
    const [brokerSaleRete, setBrokerSaleRete] = useState(0.0);
    const [companySaleRate, setCompanySaleRate] = useState(0.0);
    const [brokerManageRate, setBrokerManageRate] = useState(0.0);

    useEffect(() => {
        getServiceInfo({ id });
    }, []);

    useEffect(() => {
        setBrokerSaleRete(regFenToYuan(serviceInfo.brokerSaleRete));
        setCompanySaleRate(regFenToYuan(serviceInfo.companySaleRate));
        setBrokerManageRate(regFenToYuan(serviceInfo.brokerManageRate));
    }, [serviceInfo]);

    //提交
    const onSubmit = () => {
        setLoading(true);
        http(
            '/?cmd=com.xqxc.api.pig.mis.biz.user.goods.ExtraServiceMisService.updateExtraServiceRate',
            {
                extraServiceId: id,
                brokerSaleRete: regYuanToFen(brokerSaleRete),
                companySaleRate: regYuanToFen(companySaleRate),
                brokerManageRate: regYuanToFen(brokerManageRate)
            },
            'POST'
        )
            .then(res => {
                message.success('修改费率操作成功');
                setLoading(false);
                closeModal();
            })
            .catch(error => {
                setLoading(false);
                message.error(error.message);
            });

    };


    return <Modal
        width={800}
        centered
        title='费用比例设置'
        visible={true}
        confirmLoading={loading}
        onOk={onSubmit}
        onCancel={() => closeModal()}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        cancelText='取消'
        okText='确认'
    >
        <div className={styles.container}>
            <Divider style={{ margin: '10px 0' }} />
            <div className={styles.title}>情形：经纪人推广经纪人</div>
            <Divider style={{ margin: '10px 0' }} />
            <div className={styles.item}>
                <div className={styles.tip}>当收益对象为经纪人（推荐人）时，获取费用名称 销售收益</div>
                <XInputNum
                    label={<span><b style={{ color: '#FF0000' }}>*</b>比率(%)：</span>}
                    placeholder='请输入比率'
                    value={brokerSaleRete}
                    bindThis={setBrokerSaleRete}
                    precision={1}
                    min={0.0}
                    max={100.0}
                    bindName='brokerSaleRete' />
            </div>
            <div className={styles.item}>
                <div className={styles.tip}>当收益对象为运营公司时，获取费用名称运营公司管理费</div>
                <XInputNum
                    label={<span><b style={{ color: '#FF0000' }}>*</b>比率(%)：</span>}
                    placeholder='请输入比率'
                    value={brokerManageRate}
                    bindThis={setBrokerManageRate}
                    precision={1}
                    min={0.0}
                    max={100.0}
                    bindName='brokerManageRate' />
            </div>
            <Divider style={{ margin: '10px 0' }} />
            <div className={styles.title}>情形：运营公司推广经纪人</div>
            <Divider style={{ margin: '10px 0' }} />
            <div className={styles.item}>
                <div className={styles.tip}>当收益对象为运营公司时，获取费用名称运营公司销售收益</div>
                <XInputNum
                    label={<span><b style={{ color: '#FF0000' }}>*</b>比率(%)：</span>}
                    placeholder='请输入比率'
                    value={companySaleRate}
                    bindThis={setCompanySaleRate}
                    precision={1}
                    min={0.0}
                    max={100.0}
                    bindName='companySaleRate' />
            </div>
            <Divider style={{ margin: '10px 0' }} />
            <div className={styles.title}>情形：会员成为经纪人不分润</div>
        </div>
    </Modal>;
};
SetRate.propTypes = {
    closeModal: PropTypes.func, // 关闭弹框的回调函数
    data: PropTypes.object,
    getServiceInfo: PropTypes.func,
    serviceInfo: PropTypes.object
};
SetRate.defaultProps = {
    serviceInfo: {}
};
export default connect(state => ({
    serviceInfo: state.operationService.serviceInfo,
}), {
    ...model.actions
})(SetRate);